<template>
  <div class="bg-gray20 FULLHEIGHT">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'reviews',
};
</script>

<style lang="scss" scoped>
.FULLHEIGHT{
  flex: 1 1 Auto;
}
</style>
